import React from 'react';
import ArtworkForm from '../components/ArtworkForm';
import { useState, useEffect } from 'react';
import { useAuthContext } from '../hooks/useAuthContext';
import Navbar from '../components/Navbar';


// Components
import ArtworkDetails from '../components/ArtworkDetails';
import ArtworkSkeleton from '../components/ArtworkSkeleton';
import { useArtworksContext } from '../hooks/useArtworksContext';
import { axiosInstance } from '../context/AuthContext';

function EditorPage() {
  const { gallery, dispatch } = useArtworksContext()
  const { user } = useAuthContext()


  // Toggle Add new Artwork Form
  const [ShowCreateArtwork, setShowCreateArtwork] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  

  const handleSetupNewArtwork = () => {
    setShowCreateArtwork(true);
  };
  const handleCancelNewArtwork = () => {
    setShowCreateArtwork(false);
  };


  useEffect(() => {
    const fetchArtworks = async () => {
      if (!user?.token) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const response = await axiosInstance.get('/artworks?view=editor');
        dispatch({ type: 'SET_ARTWORKS', payload: response.data });
      } catch (err) {
        console.error('Error fetching artworks:', err);
        setError(err.response?.data?.error || 'Failed to load artworks');
      } finally {
        setIsLoading(false);
      }
    };

    fetchArtworks();
  }, [dispatch, user]);
  



  return (
    <>
      <Navbar />
      <div className="flex flex-col min-h-screen pt-4 EditorPage sm:ml-20 ml-0 mb-4">
        <div className='self-center py-8 sm:text-5xl text-4xl font-bold headFont'>
          <h1 className='text-sky-950 uppercase'>EDIT GALLERY</h1>
        </div>

        <div className='px-8 sm:px-16 gallery'>
          {error && (
            <div className="mx-auto mb-6 max-w-md rounded-lg border border-red-200 bg-red-50 p-4 text-red-700 text-sm">
              {error}
            </div>
          )}

          {isLoading ? (
            <div className="grid gap-10 lg:grid-cols-4 items-start">
              {Array.from({ length: 8 }, (_, index) => (
                <ArtworkSkeleton key={index} />
              ))}
            </div>
          ) : (
          <div className='grid gap-10 lg:grid-cols-4 items-start'>
            {/* Add Art Form Card - Shown as first item when toggled */}
            {ShowCreateArtwork ? (
              <ArtworkForm onCancel={handleCancelNewArtwork} />
            ) : (
              <div 
                onClick={handleSetupNewArtwork}
                className="w-full max-w-80 mx-auto bg-white border-2 border-dashed border-gray-300 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl hover:border-blue-400 transition-all duration-200 cursor-pointer group"
              >
                <div className="p-4 h-full flex flex-col items-center justify-center" style={{minHeight: '420px'}}>
                  <div className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-200 transition-colors duration-200">
                      <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                    </div>
                    <h3 className="font-semibold text-lg font-sans text-gray-700 group-hover:text-blue-600 transition-colors duration-200 mb-2">
                      Add New Artwork
                    </h3>
                    <p className="text-sm text-gray-500">
                      Click to add a new artwork to your gallery
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Existing Artworks */}
            {gallery && gallery.artworks?.map((artwork) => (
              <ArtworkDetails key={artwork._id} artwork={artwork} isAdminView={true} />
            ))}
          </div>
          )}
        </div>
      </div>
    </>
  );
}

export default EditorPage;